function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import noop from './noop';
class Deferred {
    // Using getter so that the state cannot be changed from outside the class.
    get state() {
        return this._state;
    }
    constructor(){
        _define_property(this, "promise", void 0);
        _define_property(this, "resolve", void 0);
        _define_property(this, "reject", void 0);
        _define_property(this, "_state", 'pending');
        let res = noop;
        let rej = noop;
        this.promise = new Promise((resolve, reject)=>{
            res = (value)=>{
                this._state = 'resolved';
                resolve(value);
            };
            rej = (reason)=>{
                this._state = 'rejected';
                reject(reason);
            };
        });
        this.resolve = res;
        this.reject = rej;
    }
}
export { Deferred as default };

//# sourceMappingURL=Deferred.js.map